module.exports = __webpack_public_path__ + "assets/img/driver-btn-69b12dc6.png";